<template>
  <div class="fixed top-0 right-0 w-70 flex justify-start items-start z-10">
    <div class="link-wrapper w-full flex flex-col mt-14">
      <a
        v-for="(link, index) in linkData"
        :key="index"
        class="w-full h-16 bg-soft-orange flex justify-center items-center"
        :href="link.href"
        target="_blank"
      >
        <img :src="`${imgPath}${link.icon}`" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      linkData: [
        {
          name: 'home',
          icon: '/slide1/ico_home.png',
          href: 'https://latale.papayaplay.com/latale.do',
        },
        {
          name: 'discord',
          icon: '/slide1/logodiscord.png',
          href: 'https://discord.com/invite/latalena',
        },
        {
          name: 'facebook',
          icon: '/slide1/ico_facebook.png',
          href: 'https://www.facebook.com/latalena/',
        },
        {
          name: 'tweeter',
          icon: '/slide1/ico_twitter.png',
          href: 'https://www.twitter.com/papaya_latale',
        },
      ],
    };
  },
};
</script>

<style>
.link-wrapper a:nth-child(2) img {
  @apply h-8;
}
</style>
